import { priceValues, priceValuesLeasing } from 'Common/filterValues';

const lowestPrice = priceValues[0].key;
const highestPrice = priceValues.slice(-1)[0].key;

/**
 * getMinRange
 * @param {number} from - from
 * @param {number} defaultVal - defaultVal
 * @return {array} - prices
 */
const getMinRange = (from, defaultVal) => {
  const minVal = priceValues.find(i => parseInt(i.key) >= from);
  return minVal ? minVal.key : defaultVal;
};

/**
 * getMaxRange
 * @param {number} to - to
 * @param {number} defaultVal - defaultVal
 * @return {array} - prices
 */
const getMaxRange = (to, defaultVal) => {
  const maxVal = priceValues.find(i => parseInt(i.key) >= to);
  return maxVal ? maxVal.key : defaultVal;
};

/**
 * getPriceFromValues
 * @param {number} priceFrom - priceFrom
 * @param {number} priceTo - priceTo
 * @param {number} selectedTo - selectedTo
 * @return {array} - prices
 */
export const getPriceFromValues = (
  priceFrom,
  priceTo,
  selectedTo,
  isLeasingPage,
  isStockCarsPage
) => {
  const minRange = getMinRange(priceFrom, lowestPrice);
  const maxRange = selectedTo || getMaxRange(priceTo, highestPrice);
  const priceValuesToUse = isLeasingPage ? priceValuesLeasing : priceValues;

  let filteredValues = priceValuesToUse.filter(
    i => parseInt(i.key) <= maxRange && parseInt(i.key) >= minRange
  );

  if (isStockCarsPage) {
    // Remove the values 1000, 2000, 1000000, and 2000000
    filteredValues = filteredValues.filter(
      i => !['1000', '2000', '1000000', '2000000'].includes(i.key)
    );
  }

  return filteredValues;
};

/**
 * getPriceToValues
 * @param {number} priceFrom - priceFrom
 * @param {number} priceTo - priceTo
 * @param {number} selectedFrom - selectedFrom
 * @return {array} - prices
 */
export const getPriceToValues = (
  priceFrom,
  priceTo,
  selectedFrom,
  isLeasingPage,
  isStockCarsPage
) => {
  const minRange = selectedFrom || getMinRange(priceFrom, lowestPrice);
  const maxRange = getMaxRange(priceTo, highestPrice);
  const priceValuesToUse = isLeasingPage ? priceValuesLeasing : priceValues;

  let filteredValues = priceValuesToUse.filter(
    i => parseInt(i.key) <= maxRange && parseInt(i.key) > minRange
  );

  if (isStockCarsPage) {
    // Remove the values 1000, 2000, 1000000, and 2000000
    filteredValues = filteredValues.filter(
      i => !['1000', '2000', '1000000', '2000000'].includes(i.key)
    );
  }

  return filteredValues;
};

/**
 * getPriceLabelsAndFields
 * @param {boolean} isLeasingPage - Indicates whether it's a leasing page
 * @param {object} fields - Object containing price-related fields
 * @param {number} fields.minLeaseMonthlyPrice - Minimum lease monthly price field
 * @param {number} fields.maxLeaseMonthlyPrice - Maximum lease monthly price field
 * @param {number} fields.minPrice - Minimum price field
 * @param {number} fields.maxPrice - Maximum price field
 * @return {object} - Returns an object containing price labels and field values
 */
export const getPriceLabelsAndFields = (isLeasingPage, fields) => {
  const priceFromLabel = !isLeasingPage ? 'Price from' : 'Min monthly price';
  const priceToLabel = !isLeasingPage ? 'Price to' : 'Max monthly price';

  const fieldsMinPrice = isLeasingPage
    ? fields.minLeaseMonthlyPrice
    : fields.minPrice;
  const fieldsMaxPrice = isLeasingPage
    ? fields.maxLeaseMonthlyPrice
    : fields.maxPrice;

  const minPriceOrMinLeasePrice = isLeasingPage
    ? 'minLeaseMonthlyPrice'
    : 'minPrice';
  const maxPriceOrMaxLeasePrice = isLeasingPage
    ? 'maxLeaseMonthlyPrice'
    : 'maxPrice';

  return {
    priceFromLabel,
    priceToLabel,
    fieldsMinPrice,
    fieldsMaxPrice,
    minPriceOrMinLeasePrice,
    maxPriceOrMaxLeasePrice
  };
};



// WEBPACK FOOTER //
// ./src/Common/calculatePriceIncrements/index.js